/** Articles in the magazine hero: the feature plus its 2×2 of portrait tiles. */
const HERO_TILE_COUNT = 5;
/** The wide hero drops the feature to one row, so two more tiles fit beside it. */
const WIDE_HERO_TILE_COUNT = 7;

export interface ArticleGridLayout {
    /** Articles the magazine hero renders; the rest go to the continuation grid. */
    heroCount: number;
    /**
     * True when the feature tile shares its row rather than spanning two. The
     * feature's art is landscape and the tiles beside it are portrait, so a
     * two-row feature leaves a tall gap under itself — fine as the section's
     * closing whitespace (the Figma's 5-tile layout), but a hole in the middle
     * of the page once a continuation grid follows it.
     */
    isWideHero: boolean;
}

/**
 * Pick the magazine hero's shape for this many articles.
 *
 * At or below five tiles the hero keeps the Figma layout exactly: a two-row
 * feature beside a 2×2 of portrait tiles, its trailing gap closing the section.
 * Past that the continuation grid follows, so the feature drops to a single row
 * and two extra portrait tiles fill the space it used to leave empty.
 *
 * Only the Articles tab spills into a continuation grid — the overview caps at
 * five tiles, so it always keeps the Figma layout.
 */
export const getArticleGridLayout = (
    articleCount: number,
    isTab: boolean,
): ArticleGridLayout => {
    const isWideHero = isTab && articleCount > HERO_TILE_COUNT;
    return {
        heroCount: isWideHero ? WIDE_HERO_TILE_COUNT : HERO_TILE_COUNT,
        isWideHero,
    };
};
